import Player from '@vimeo/player';

( function ( $ ) {
	$( '.video__play' ).on( 'click', function () {
		const iframe = $( this ).parents( '.video__wrapper' ).find( 'iframe' );

		if ( $( iframe ).length === 0 ) {
			$( this )
				.addClass( 'hide' )
				.parents( '.video__wrapper' )
				.find( 'video' )
				.get( 0 )
				.play();
			$( '.video__play' )
				.parents( '.video__wrapper' )
				.find( 'video' )
				.attr( 'controls', true );
		}

		if ( $( iframe ).length !== 0 ) {
			$( this ).addClass( 'hide' );
			$( this )
				.parents( '.video__wrapper' )
				.find( '.video__poster-wrapper' )
				.hide();
			const player = new Player( iframe );
			player.play();
		}
	} );

	$( '.video-testimonials__item-play' ).on( 'click', function () {
		const iframe = $( this )
			.parents( '.video-testimonials__item-video' )
			.find( 'iframe' );

		if ( $( iframe ).length === 0 ) {
			$( this )
				.addClass( 'hide' )
				.parents( '.video-testimonials__item-video' )
				.find( 'video' )
				.get( 0 )
				.play();
			$( '.video-testimonials__item-play' )
				.parents( '.video-testimonials__item-video' )
				.find( 'video' )
				.attr( 'controls', true );
		}

		if ( $( iframe ).length !== 0 ) {
			$( this ).addClass( 'hide' );
			$( this )
				.parents( '.video-testimonials__item-video' )
				.find( '.video-testimonials__item-poster-wrapper' )
				.hide();
			const player = new Player( iframe );
			player.play();
		}
	} );
} )( jQuery );
